import React, { useState } from 'react';
import { TextField } from '@mui/material';
import useBackHandler from '../hooks/useBackHandler';

// MUI Select creates a Menu internally, outside the explicit overlay inventory.
export default function BackAwareTextField({ SelectProps = {}, ...props }) {
    const [open, setOpen] = useState(false);
    const close = event => { setOpen(false); SelectProps.onClose?.(event); };
    useBackHandler(Boolean(props.select && open), close, 1300);
    return <TextField {...props} SelectProps={props.select ? {
        ...SelectProps,
        open,
        onOpen: event => { setOpen(true); SelectProps.onOpen?.(event); },
        onClose: close,
        MenuProps: { ...SelectProps.MenuProps, disableScrollLock: true },
    } : SelectProps} />;
}
